import React from 'react';
import { UrgencyBlock } from './UrgencyBlock';
import { PricingCards } from './PricingCards';
export function FinalCTA() {
  return <section className="py-10 md:py-20 px-4 bg-navy-50 border-t border-navy-100" data-id="element-73">
      <div className="max-w-5xl mx-auto text-center mb-8" data-id="element-74">
        <h2 className="font-display text-5xl md:text-6xl text-danger uppercase tracking-wide" data-id="element-75">
          No dejes pasar esta oportunidad
        </h2>
      </div>

      <UrgencyBlock data-id="element-76" />
      <PricingCards data-id="element-77" />
    </section>;
}